import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { IStudentSearchParameters } from 'src/app/Models/IStudentSearchParameters';

@Component({
  selector: 'app-_201_AdministrativeServiceComplianceRptParams',
  templateUrl: './_201_AdministrativeServiceComplianceRptParams.component.html',
  styleUrls: ['./_201_AdministrativeServiceComplianceRptParams.component.css']
})
export class _201_AdministrativeServiceComplianceRptParamsComponent implements OnInit {
  _baseUrl: string;

  selectedValue2: string = 'val3';  //radiobutton

  _academicYear: string = null;
  _attendancePeriod: string = null;
  info: string[]; //textarea
  _PAUid: string = null;
  _siteId: string = null;
  _service: string = null;
  _attendancePeriodValue: string = null;
  _attendancePeriodLabel: string = null;
  _startDate: string = null;
  _endDate: string = null;

  _myGlobals: Globals;

  date: Date; //datepicker
  radioBtnSelection: string = 'Current';
  academicYear: SelectItem;
  attendancePeriod: SelectItem;//dropdowns
  selectedPAU: string;
  selectedSite: string;
  selectedServices: string[];   

  showSpinner: boolean = false;

  //lookups
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  attendancePeriodList: ILookupBase[] = [{ value: null, label: "-- Select Attendance Period --", shortText: null, updatedOn: null }];
  academicYearList: ILookupBase[] = [{ value: null, label: "-- Select Academic Year --", shortText: null, updatedOn: null }];
  lookupSiteList: ILookupBase[] = [{ value: null, label: "-- Select PAU to view sites --", shortText: null, updatedOn: null }];
  lookupPAUList: ILookupBase[] = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }];
  lookupServiceList: ILookupBase[] = [{ value: null, label: "-- NO SERVICES TO VIEW --", shortText: null, updatedOn: null }];
  _lookupService: LookupService;
  _reportService: ReportService;


  constructor(lookupService: LookupService, reportService: ReportService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._baseUrl = baseUrl;
    this._myGlobals = globals; 
  }

  ngOnInit() {
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.LoadLookupValues();
  }

  LoadLookupValues(): void {
    this._lookupService.getLookupAcademicYearList(this._baseUrl + 'api/Lookup/GetAcademicYearList/')
      .subscribe((res: ILookupBase[]) => {
        this.academicYearList = res.reverse();
        if (this._academicYear == null) {
          this.academicYear = this.academicYearList[0];
          this._academicYear = this.academicYearList[0].value;
        }
        let acYear = (new Date().getMonth() + 1) >= 7 ? new Date().getFullYear() + "-" + (new Date().getFullYear() + 1) : (new Date().getFullYear() - 1) + "-" + new Date().getFullYear();
        this._lookupService.getLookupAttendancePeriod(this._baseUrl + 'api/Lookup/GetAttendancePeriodList/' + (this._academicYear == null ? acYear : this._academicYear))
          .subscribe((res: ILookupBase[]) => {
            if (!res || res.toString() === "") {
              this.attendancePeriodList = [{ value: null, label: "-- NO PAUS TO VIEW ! --", shortText: null, updatedOn: null }]
            }
            else {
              this.attendancePeriodList = res.reverse();
              this.attendancePeriod = this.attendancePeriodList[0];
              this._attendancePeriodLabel = this.attendancePeriodList[0].label;
              this.setAttendancePeriod(this.attendancePeriod);
            }
          },
            err => console.error(err)
          );
      },
        err => console.error(err)
      );
    this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupPAUList = [{ value: null, label: "-- NO PAUS TO VIEW ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupPAUList = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }].concat(res);
          this.selectedPAU = this.lookupPAUList[0].value;
        }
        this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
          .subscribe((res: ILookupBase[]) => {
            if (!res || res.toString() === "") {
              this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
            }
            else {
              this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
              this.selectedSite = this.lookupSiteList[0].value;

              //Service lookup
              let params = {} as IStudentSearchParameters;
              params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
              params.siteIdArray = this.getSiteIdList().split('^');

              this._lookupService.getLookupService(this._baseUrl + 'api/Lookup/GetServiceList/', params)
                .subscribe((res: ILookupBase[]) => {
                  if (!res || res.toString() === "") {
                    this.lookupServiceList = [{ value: null, label: "-- NO SERVICES TO VIEW ! --", shortText: null, updatedOn: null }]
                  }
                  else {
                    this.lookupServiceList = [{ value: null, label: "-- ALL Services --", shortText: null, updatedOn: null }].concat(res);

                    this.selectedServices = null;
                  }
                },
                  err => console.error(err)
                );
            }
          },
            err => console.error(err)
          );
      },
        err => console.error(err)
    );
  }

  LookupSites(id): void {
    this._PAUid = (id.value != null ? id.value : '');
    var param = (typeof id == "string") ? id : (id.value != null ? id.value : '');
    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/getLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + param)
        .subscribe((res: ILookupBase[]) => {
          if (!res || res.toString() === "") {
            this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
          }
          else {
            this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
            this.selectedSite = this.lookupSiteList[0].value;
          }
        },
          err => console.error(err)
        );
    
  }

  checkRadioButton(id): void {
    this.radioBtnSelection = id;
  }

  setSite(id): void {
    this._siteId = id.value;
  }

  setAcademicYear(id): void { this._academicYear = id.value; this.LoadLookupValues() }
  //setAttendancePeriod(id): void { this._attendancePeriod = id.value }

  setAttendancePeriod(id): void {
    this._attendancePeriodValue = id.value;
    this._attendancePeriodLabel = this.attendancePeriodList.find(x => x.value === id.value).label;
    this._startDate = this._attendancePeriodLabel.slice(this._attendancePeriodLabel.indexOf(' - ') + 3, this._attendancePeriodLabel.indexOf(' to '))
    this._endDate = this._attendancePeriodLabel.slice(this._attendancePeriodLabel.indexOf(' to ') + 4)
  }


  setService(id): void { this._service = id.value }


  getSiteIdList(): string {
    if (this._siteId != null) { return this._siteId }
    else {
      let siteIdList: string;
      this.lookupSiteList.forEach((site, index, arr) => {
        if ((site.label != null) && (site.label != "-- Select PAU to view sites --") && (site.label != "-- NO SITES TO VIEW --")) {
          if (site.label != "-- All Sites --") siteIdList += site.value + '^';
        }
      });
      return siteIdList.slice(0, siteIdList.length - 1).replace('undefined', '');
    }
  }

  getPAUIdList(): string {
    let pAUIdList: string;
    this.lookupPAUList.forEach((pau, index, arr) => {
      if ((pau.label != null) && (pau.label != "-- NO PAUS TO VIEW --")) {
        if (pau.label != "-- All PAUs --") pAUIdList += pau.value + '^';
      }
    });
    return pAUIdList.slice(0, pAUIdList.length - 1).replace('undefined', '').replace('null', '');
  }

  getServiceList(): string {
    let serviceList: string = "";
    this.selectedServices.forEach((svc, index, arr) => {
      if ((svc != null) && (svc != "-- NO SERVICES TO VIEW --")) {
        if (svc != "-- All Services --") serviceList += svc + '^';
      }
    });
    return serviceList.slice(0, serviceList.length - 1).replace('undefined', '').replace('null', '');
  }

  getAllServiceList(): string {
    let serviceList: string;
    this.lookupServiceList.forEach((svc, index, arr) => {
      if ((svc.label != null) && (svc.label != "-- NO SERVICES TO VIEW --")) {
        if (svc.label != "-- All Services --") serviceList += svc.value + '^';
      }
    });
    return serviceList.slice(0, serviceList.length - 1).replace('undefined', '').replace('null', '');
  }

  viewReport() {
    let reportParamArray: IReportParameter[] = [];
    let selectedPauItem: ILookupBase = this.lookupPAUList.find(pau => pau.value === this.selectedPAU);
    let selectedSiteItem: ILookupBase = this.lookupSiteList.find(y => y.value === this.selectedSite);
    //var selectedServicesString = ''; // this.lookupServiceList.find(z => z.value === this._service).label;
    //var selectedAcademicYear = this.academicYearList.find(l => l.value === this._academicYear).label;
    //var selectedAttendacePeriod = this.attendancePeriodList.find(k => k.value === this._attendancePeriod).label;

    var selectedAcademicYear = this.academicYear.label;
    //var selectedAttendacePeriod = this.attendancePeriod.toString();
    var selectedServicesString = ''; 

    let count = this.selectedServices !== null && this.selectedServices !== undefined ? this.selectedServices?.length : 0;
    if (count > 1) {
      for (var i = 0; i < count; i++) {
        if (selectedServicesString.length > 1) {
          selectedServicesString += '^';
        }
        let selectedServiceItem: ILookupBase = this.lookupServiceList.find(s => s.value === this.selectedServices[i]);
        selectedServicesString += selectedServiceItem.label;
      }
    }
    else {
      if (this.selectedServices !== null && this.selectedServices !== undefined) {
        let selectedServiceItem: ILookupBase = this.lookupServiceList.find(s => s.value === this.selectedServices[0]);
        selectedServicesString += selectedServiceItem.label;
      }
      else {
        selectedServicesString += this.lookupServiceList[0].label;
      }
    }

    reportParamArray.push(
      //{ parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      //{ parameterName: 'CustomWatermarkText', parameterValue: '' },


      { parameterName: 'AcademicYear', parameterValue: this._academicYear },
      { parameterName: 'AttendancePeriod', parameterValue: this._attendancePeriodLabel },
      { parameterName: 'PAUIdList', parameterValue: this.selectedPAU ? this.selectedPAU : this.getPAUIdList().slice(1) },
      { parameterName: 'SiteIdList', parameterValue: this.selectedSite != null ? this.selectedSite : this.getSiteIdList().replace('undefined', '') },
      { parameterName: 'SpecialEducationServiceIdList', parameterValue: (this.selectedServices != null && this.selectedServices?.length >= 1 && this.selectedServices[0] !== null && this.selectedServices[0] !== undefined && selectedServicesString != "-- NO SERVICES TO VIEW ! --") ? this.getServiceList() : this.getAllServiceList() },
      { parameterName: 'StartingDate', parameterValue: this._startDate },   
      { parameterName: 'EndingDate', parameterValue: this._endDate },
      { parameterName: 'PAU_Name', parameterValue: (selectedPauItem != null && selectedPauItem.label != '-- ALL PAUs --') ? selectedPauItem.label : 'All PAUs' },
      { parameterName: 'SiteName', parameterValue: (selectedSiteItem != null && selectedSiteItem.label != "-- Select PAU to view sites --") ? selectedSiteItem.label.replace('-- ', '').replace(' --', '') : 'All Sites' },
      { parameterName: 'ServiceName', parameterValue: (this.selectedServices != null && selectedServicesString != "-- ALL Services --") ? selectedServicesString.replace('-- ', '').replace(' --', '') : 'All Services' },
      { parameterName: 'StudentSelection', parameterValue: this.radioBtnSelection },
      { parameterName: 'EPICUserName', parameterValue: '' }
    );

    let now = new Date();
    let localReportFileName = '201-AdminServiceCompliance_' + now.toISOString().slice(0, 10) + '_' + now.toTimeString().slice(0, 5) + '.pdf';
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = ' SpedXReports ';
    reportRequest.reportFileName = "IEP_SpecialEd_AdministrativeServiceComplianceReport";
    reportRequest.reportSpecificParameterArray = reportParamArray;

    this.showSpinner = true;
    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }




}
